import React from 'react';
import CanonicalResellerMerchantComponent from './canonical-reseller-merchant.component';

const CanonicalResellerMerchant = (props) => {
    return <CanonicalResellerMerchantComponent {...props} />;
};

export default CanonicalResellerMerchant;
